import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ForbiddenContainer } from './Style';
import { Link } from 'react-router-dom';
import background from '../../../Assets/images/background.svg';
import { lockedBig } from '../../../Assets/images/lockedBig';

const Forbidden: React.FunctionComponent = (): JSX.Element => {
  const { t } = useTranslation();
  const style = {
    backgroundImage: `url(${background})`,
    backgroundSize: 'cover',
    backgroundPositionY: 'center',
    backgroundPositionX: 'center',
    backgroundAttachment: 'fixed',
    minHeight: 'calc(100vh - 62px)',
  };
  return (
    <ForbiddenContainer style={style}>
      <div>
        {lockedBig}
        <h2>{t('You Are Not Allowed to Access This Page')}</h2>
        <Link to="/courses">{t('Go to courses page')}</Link>
      </div>
    </ForbiddenContainer>
  );
};

export default Forbidden;
